export class Table {
    constructor(tableEl) {
        this.tableEl = tableEl;
        this.rows = Array.from(tableEl.querySelectorAll('tr'));
        this.singleColTable = this.rows[0].querySelectorAll('th, td').length === 1;

        if (!this.singleColTable) {
            this.addDividerRows();
        }
        this.setupAccessibleMarkup();

        // Table el is removed here, call this last.
        this.setupResponsiveMarkup();
    }

    addDividerRows() {
        // Custom style empty rows as dividers
        this.rows.forEach((row) => {
            const cells = Array.from(row.querySelectorAll('td'));

            const contentCount = cells.reduce((acc, current) => {
                return acc + (current.innerHTML === '' ? 0 : 1);
            }, 0);

            row.classList = contentCount === 1 ? 'table-divider-row' : '';
        });
    }

    // Modify redactor tables to comply with accessibility guidelines... Quite hacky
    setupAccessibleMarkup() {
        // Swap in <th> elements if first col is vertical header cells
        const firstColCells = Array.from(this.tableEl.querySelectorAll('tr td:first-child'));
        const hasVerticalHeaders = firstColCells.every((cell) => this.isHeaderCell(cell));
        if (hasVerticalHeaders) {
            firstColCells.forEach((cell) => {
                cell.outerHTML = `<th scope="row">${cell.innerText}</th>`;
            });
        }

        // Swap in <th> elements if first row is horizontal header cells.
        const firstRowCells = Array.from(this.tableEl.querySelectorAll('tr:first-child td'));
        const hasHorizontalHeaders = firstRowCells.every((cell) => this.isHeaderCell(cell));
        if (hasHorizontalHeaders) {
            firstRowCells.forEach((cell) => {
                cell.outerHTML = `<th scope="col">${cell.innerText}</th>`;
            });
        }

        //If headers are in X and Y axes, then row[0]/col[0] will be empty. This should not be a <th> , should be <td>
        const topLeftCell = this.tableEl.querySelector('thead th:first-child, tr th:first-child');
        if (topLeftCell && topLeftCell.textContent === '') {
            const replacementCell = document.createElement('td');
            replacementCell.innerHTML = topLeftCell.innerHTML;
            topLeftCell.parentNode.replaceChild(replacementCell, topLeftCell);
        }
    }

    isHeaderCell(cell) {
        return cell.textContent === '' || cell.querySelector('strong');
    }

    setupResponsiveMarkup() {
        // Replace table with responsive setup that overlays identical tables for horizontal scroll on mobile
        this.tableEl.insertAdjacentHTML(
            'beforeBegin',
            `
                <div class="table-outer-wrap ${this.singleColTable && 'single-col-table'}">
                    <div class="table-wrap">
                        <table>${this.tableEl.innerHTML}</table>
                    </div>
                    <div class="overlay-sticky-col">
                        <table>${this.tableEl.innerHTML}</table>
                    </div>
                </div>
            `
        );
        this.tableEl.remove();
    }
}

export default (() => {
    const tables = Array.from(document.querySelectorAll('.wysiwyg table:not(.borderless)'));

    tables.forEach((table) => {
        new Table(table);
    });
})();
